<template>
  <div class="map-marker-detials">
    <img src="/static/icons/Asset 4.png" width="16px" alt="map marker from" v-if="title === 'From'">
    <img src="/static/icons/Asset 6.png" width="16px" alt="map marker to" v-else>
    <p class="material-details">
      <strong>{{ title }}:</strong><br>
      {{ address }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['location', 'title'],

  computed: {
    haveLocation () {
      return this.location !== null && this.location !== undefined
    },

    address () {
      if (!this.haveLocation) {
        return '-'
      }

      const l = this.location.decorated

      return `${l.street_number} ${l.street_name} ${l.suburb}, ${l.state} ${l.postcode}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// JobLocation.vue?568284fd